<template>
  <div class="bg-muted-100 dark:bg-muted-900  min-h-screen w-full">
    <slot />
  </div>
</template>
<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
const { $dataService } = useNuxtApp()
const router = useRouter()
const event = useRequestEvent()
const validateUser = async () => {
  if (!import.meta.client) return

  try {
    if (!await $dataService.reAuthenticate()) {
      navigateTo('/', { redirectCode: 302 })
    }
  }
  catch (e) {
    navigateTo('/', { redirectCode: 302 })
  }
}

validateUser()

const onFocus = async () => {
  validateUser()
}
const timeout = ref(null)

onMounted(() => {
  window.addEventListener('focus', onFocus)
  timeout.value = setTimeout(() => {
    validateUser()
  }, 60000)
})

onBeforeUnmount(() => {
  window.removeEventListener('focus', onFocus)
  clearTimeout(timeout.value)
})
</script>
